import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { BM_PERIODS } from '../../../constants/enrollment';
import { getCompositeScore } from '../composite-score/CompositeScore';
import { DIBELS8, IDEL2 } from '../../../constants/applications';

const COMPOSITE_SCORE = 'Composite Score';
const PUNTAJE_COMPUESTO = 'Puntaje compuesto';

const titleText = {
    [DIBELS8]: COMPOSITE_SCORE,
    [IDEL2]: PUNTAJE_COMPUESTO,
};

const CompositeScoreRow = ({ appName, student, benchmarkPeriods, hasFourthPeriod }) => (
    <div className={classNames('dashboard-composite-scores', { 'dashboard-has-fourth-period': hasFourthPeriod })}>
        <div className='dashboard-title'>
            <div className='dashboard-title-text'>{titleText[appName]}</div>
        </div>

        {benchmarkPeriods.map(period => (
            <div key={period}>{getCompositeScore(appName, student, period)}</div>
        ))}
    </div>
);

CompositeScoreRow.propTypes = {
    appName: PropTypes.string.isRequired,
    student: PropTypes.object.isRequired,
    benchmarkPeriods: PropTypes.arrayOf(PropTypes.string),
    hasFourthPeriod: PropTypes.bool,
};

CompositeScoreRow.defaultProps = {
    benchmarkPeriods: BM_PERIODS,
    hasFourthPeriod: false,
};

export default CompositeScoreRow;
